/** Resolve Stripe publishable key from checkout response, billing status, or build-time env. */
export function resolveStripePublishableKey({ checkoutData, billing } = {}) {
    const candidates = [
        checkoutData?.publishable_key,
        billing?.stripe_billing?.publishable_key,
        process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
    ];
    for (const key of candidates) {
        if (typeof key === "string" && key.trim()) {
            return key.trim();
        }
    }
    return null;
}

/** @returns {"test" | "live" | null} */
export function stripePublishableKeyMode(publishableKey) {
    if (typeof publishableKey !== "string") {
        return null;
    }
    if (publishableKey.startsWith("pk_test_")) {
        return "test";
    }
    if (publishableKey.startsWith("pk_live_")) {
        return "live";
    }
    return null;
}

/** Returns a user-facing message when frontend and backend Stripe modes disagree. */
export function stripeKeyModeMismatchMessage({ publishableKey, serverMode }) {
    const clientMode = stripePublishableKeyMode(publishableKey);
    if (!clientMode || !serverMode || clientMode === serverMode) {
        return null;
    }
    return (
        `Stripe keys do not match: this page is using a ${clientMode} publishable key `
        + `but the server created the checkout in ${serverMode} mode. `
        + "Use the same mode for STRIPE_API_KEY and STRIPE_PUBLISHABLE_KEY (or REACT_APP_STRIPE_PUBLISHABLE_KEY)."
    );
}
